import React from 'react';
import '../styles/Sidebar.css';
import { Hash, Ticket, Users, Settings, LogOut, Shield, BookOpen } from 'lucide-react';


const Sidebar = ({ user, handleLogout, activeTab, setActiveTab, unreadCount}) => {
  // Define all possible menu items
  const allMenuItems = [
    { id: 'tickets', label: 'My Tickets', icon: <Ticket size={18} />, roles: ['Admin', 'Engineer'] },
    { 
      id: 'chat', 
      label: 'Staff Chat', 
      icon: <Hash size={18} />, 
      roles: ['Admin', 'Engineer'],
      showBadge: true // Mark that this item can have a badge
    },
    { id: 'team', label: 'Team Members', icon: <Users size={18} />, roles: ['Admin'] }, 
    { id: 'scripts', label: 'Call Scripts', icon: <BookOpen size={18} />, roles: ['Admin', 'Engineer'] }, // NEW ITEM
    { id: 'settings', label: 'System Settings', icon: <Settings size={18} />, roles: ['Admin', 'Engineer'] },
  ];

  // Filter items based on the current user's role
  const menuItems = allMenuItems.filter(item => item.roles.includes(user?.role));

  return (
    <aside className="sidebar unique-sidebar">
      <div className="sidebar-header">
        <div className="logo">
          <div className="logo-icon-box">
            <Ticket size={22} color="white" />
          </div>
          <span>Ticketing<b style={{ color: '#6366f1' }}>.io</b></span>
        </div>
      </div>

      <nav className="nav-menu">
        <span className="nav-section-title">OVERVIEW</span>
        
        {menuItems.map((item) => (
          <button 
            key={item.id}
            className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
            onClick={() => setActiveTab(item.id)}
          >
            <div className="nav-icon-wrapper">{item.icon}</div>
            <span>{item.label}</span>
            {item.id === 'chat' && unreadCount > 0 && (
              <div style={{
                marginLeft: 'auto',
                background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
                color: 'white',
                fontSize: '10px',
                padding: '2px 7px',
                borderRadius: '20px',
                boxShadow: '0 4px 10px rgba(99, 102, 241, 0.4)',
                border: '2px solid white'
              }}>
                {unreadCount}
              </div>
            )}
                        {activeTab === item.id && <div className="active-glow"></div>}
          </button>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="premium-user-card">
          <div className="user-avatar-container">
            <div className="avatar-gradient-ring">
              <div className="avatar-inner">
                {user?.name?.charAt(0) || 'U'}
              </div>
            </div>
            <div className="online-indicator"></div>
          </div>
          <div className="user-details">
            <p className="user-name">{user?.name || 'Guest User'}</p>
            <p className="user-role" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              {user?.role === 'Admin' && <Shield size={10} fill="#6366f1" color="#6366f1" />}
              {user?.role === 'Admin' ? 'Administrator' : 'Support Engineer'}
            </p>
          </div>
          <button 
            onClick={handleLogout} 
            className="minimal-logout" 
            title="Logout"
          >
            <LogOut size={18} strokeWidth={2.5} />
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;